const sections = {
  about: "About me",
  projects: "Recent Projects",
  skills: "Skills",
  contact: "Get in touch 🤙",
};

export default sections;
